import { ReactNode, useEffect, useState } from 'react'
import BlankLayout from 'src/materio/@core/layouts/BlankLayout'
import LicensePicker from 'src/features/signup/LicensePicker';
import { client } from 'src/utils/axios-client';
import { licensePlanEndpoint } from 'src/configs/endpoints';
import { PricingPlan } from 'src/types/common';
import RegisterUserForm from 'src/features/signup/RegisterUserForm';
import _ from 'lodash';

const Register = () => {
    const [plans, setPlans] = useState([] as PricingPlan[])
    const [planType, setPlanType] = useState(null as null | string);
    const [plan, setPlan] = useState(null as null | string);

    useEffect(() => {
        const loadPlans = async () => {
            const response = await client.get(licensePlanEndpoint);
            setPlans(response.data);
        }

        loadPlans();
    },[])    

    const onPlanSelected = (selectedPlan: string, selectedPlanType: string) => {
        setPlan(selectedPlan);
        setPlanType(selectedPlanType);
    }

    return <div>
        {/*{plan === null && <LicensePicker pricingPlans={plans} onPlanSelected={onPlanSelected} />}*/}
        <RegisterUserForm /> 
    </div>
}

Register.getLayout = (page: ReactNode) => <BlankLayout>{page}</BlankLayout>

Register.guestGuard = true

export default Register
